import DashboardStats from "../../components/dashboard-stats";

export default function Dashboard() {
    return <div>
        <div className="rounded-md overflow-hidden bg-gray-100 p-5">
            <DashboardStats />
        </div>
    </div>
}